module.exports = __webpack_public_path__ + "img/@work_bottom_m.9b773da3.jpg";